module.exports = __webpack_public_path__ + "assets/e9322e2c3a6d87e686f11ec6d88560b2.svg";